import { GeneratorSwitchButtonTrueIcon } from '../Icons';

interface AlertProps {
  error: Error;
}

export default function JenErrorToast({ error = new Error('NOVICE USER CAN ONLY CREATE ONE FOLDER.') }: AlertProps) {
  //When an unexpected error occurs, we need the error text to be user friendly. Next text : Unexpected Error Occurred: Please try again soon.
  const displayMessage =
    error.name === 'Error' && String(error.message) ? String(error.message) : 'Unexpected Error Occurred: Please try again soon.';

  return (
    <div className="bg-black p-4 rounded-lg flex items-center justify-between max-w-4xl">
      <div className="flex items-center gap-3">
        <div className="relative scale-150">
          <GeneratorSwitchButtonTrueIcon />
        </div>
        <span className="text-jen-orange font-pressura-mono text-[1rem] font-bold tracking-wider">ALERT</span>
      </div>
      <span className="text-jen-orange font-pressura-mono text-[0.8rem] font-bold tracking-wider ml-4">{displayMessage}</span>
    </div>
  );
}
